import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function PengumumanAgenda() {
  const [pengumuman, setPengumuman] = useState([]);
  const [agenda, setAgenda] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const q = query(
        collection(db, "pengumumanAgenda"),
        orderBy("tanggal", "desc")
      );
      const snap = await getDocs(q);
      const data = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setPengumuman(data.filter((d) => d.type === "pengumuman"));
      setAgenda(data.filter((d) => d.type === "agenda"));
    };
    fetchData();
  }, []);

  return (
    <section
      className="pengumuman-agenda-section py-5"
      style={{
        background: `
          linear-gradient(
            to bottom,
            #F5F7FA 0%,
            #E3F2FD 35%,
            #E8F5E9 65%,
            #FFFFFF 100%
          )
        `,
      }}
    >
      <div className="container">
        <div className="row">

          {/* ================= PENGUMUMAN ================= */}
          <div className="col-lg-6 mb-4">
            <h3
              className="fw-bold mb-4 text-center"
              style={{ color: "#0D47A1" }}
            >
              Pengumuman
            </h3>

            {pengumuman.length === 0 && (
              <p className="text-center text-muted">
                Tidak ada pengumuman.
              </p>
            )}

            {pengumuman.map((p, idx) => (
              <motion.div
                key={p.id}
                className="card mb-3 shadow pengumuman-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: idx * 0.15 }}
              >
                <div className="card-body">
                  <p className="card-date mb-1">
                    {new Date(p.tanggal).toLocaleDateString()}
                  </p>

                  <Link
                    to={`/pengumumanagenda/${p.id}`}
                    className="card-title h6 text-decoration-none"
                    style={{ color: "#1F2937" }}
                  >
                    {p.judul}
                  </Link>

                  {p.deskripsi && (
                    <p className="mt-2 text-secondary">
                      {p.deskripsi.length > 100
                        ? p.deskripsi.substring(0, 100) + "..."
                        : p.deskripsi}
                    </p>
                  )}
                </div>
              </motion.div>
            ))}
          </div>

          {/* ================= AGENDA ================= */}
          <div className="col-lg-6 mb-4">
            <h3
              className="fw-bold mb-4 text-center"
              style={{ color: "#1B5E20" }}
            >
              Agenda Sekolah
            </h3>

            {agenda.length === 0 && (
              <p className="text-center text-muted">
                Tidak ada agenda terbaru.
              </p>
            )}

            {agenda.map((a, idx) => (
              <motion.div
                key={a.id}
                className="card mb-3 shadow agenda-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: idx * 0.15 }}
              >
                <div className="card-body">
                  <p className="card-date mb-1">
                    {new Date(a.tanggal).toLocaleDateString()}
                  </p>

                  <h6
                    className="card-title"
                    style={{ color: "#1F2937" }}
                  >
                    {a.judul}
                  </h6>

                  {a.lokasi && (
                    <p className="mb-1 text-secondary">
                      {a.lokasi}
                    </p>
                  )}

                  {a.deskripsi && (
                    <p className="mt-1 text-secondary">
                      {a.deskripsi.length > 100
                        ? a.deskripsi.substring(0, 100) + "..."
                        : a.deskripsi}
                    </p>
                  )}
                </div>
              </motion.div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}
